import React, { useState, useEffect } from "react";
import {
  Tabs,
  Tab,
  Typography,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  Radio,
  RadioGroup,
  FormLabel,
  TextField,
  InputProps,
  Button,
} from "@mui/material";
import moment from "moment-timezone";

import app from "../../utils/firebase";
import { ref, set } from "firebase/database";

import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

import Swal from "sweetalert2";

// core components
import Navbar from "components/Navbars/Navbar.js";
import SubHeader from "components/Headers/SubHeaderBanner";
import DarkFooter from "components/Footers/DarkFooter.js";
import PanelCountdown from "components/PanelCountdown";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import PersonIcon from "@mui/icons-material/Person";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import "./style.scss";
import DtPicker from "react-calendar-datetime-picker";
import "react-calendar-datetime-picker/dist/index.css";

// import { LocalizationProvider } from '@mui/x-date-pickers';
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import { DateRangePicker } from '@mui/x-date-pickers/DateRangePicker';
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import axios from "axios";

const style = {
  noBorder: {
    border: "none",
  },
  root: {
    borderColor: "orange",
  },
};

function Hotel() {
  const db = app();

  const [selectedDate, handleDateChange] = useState(new Date());

  React.useEffect(() => {
    document.body.classList.add("index-page");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    // window.scrollTo(0, 0);
    // document.body.scrollTop = 0;
    return function cleanup() {
      document.body.classList.remove("index-page");
      document.body.classList.remove("sidebar-collapse");
    };
  });

  const validation = Yup.object().shape({
    hotel_name: Yup.string().required("This is a required field"),
    room_type: Yup.string().required("This is a required field"),
    name: Yup.string().required("This is a required field"),
    contact_number: Yup.string().required("This is a required field"),
    email: Yup.string().email().required("This is a required field"),
    airport_transfer: Yup.string().required("This is a required field"),
  });

  const optionsForm = { resolver: yupResolver(validation) };
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm(optionsForm);

  const [dateCalendar, setDateCalendar] = useState(null);
  // const [value, setValue] = React.useState(0);

  let date = moment().tz("Asia/Singapore").format("ddd, MMM D YYYY");

  const [checkInvalue, setCheckInvalue] = useState(moment("2/18/2025"));
  const [checkOutvalue, setCheckOutvalue] = useState(moment("2/22/2025"));

  const options = [
    {
      label: "Danang Marriott Resort & Spa",
      value: "4,200,000 VND",
    },
    // {
    //     label: "Le Meridien Mina Seyahi",
    //     value: "AED 3‘750",
    // }
  ];

  const dates = [
    "2 Mar, Mon",
    "3 Mar, Tue",
    "4 Mar, Wed",
    "5 Mar, Thu",
    "6 Mar, Fri",
  ];

  // Sample Data: prices per date per room type
  const roomData = [
    {
      type: "Single (1 breakfast)",
      prices: {
        "2 Mar, Mon": "MOP/HKD 1,140 nett",
        "3 Mar, Tue": "MOP/HKD 1,140 nett",
        "4 Mar, Wed": "MOP/HKD 1,140 nett",
        "5 Mar, Thu": "MOP/HKD 1,140 nett",
        "6 Mar, Fri": "MOP/HKD 1,890 nett",
      },
    },
    {
      type: "Double (2 breakfast)",
      prices: {
        "2 Mar, Mon": "MOP/HKD 1,420 nett",
        "3 Mar, Tue": "MOP/HKD 1,420 nett",
        "4 Mar, Wed": "MOP/HKD 1,420 nett",
        "5 Mar, Thu": "MOP/HKD 1,420 nett",
        "6 Mar, Fri": "MOP/HKD 2,160 nett",
      },
    },
  ];
  const [hotelDetails, setHotelDetails] = useState({});

  const getHotelCalendar = (data) => {
    console.log(data);
    setHotelDetails(data);
  };

  // const handleChange = (event, newValue) => {
  //     setValue(newValue);
  //     event.preventDefault()
  // };

  const handleChange = (e) => {
    setHotelDetails({ value: e.target.value });
    e.preventDefault();
  };

  const showAlert = () => {
    Swal.fire({
      title: "Success",
      text: "Alert successful",
      icon: "success",
      confirmButtonText: "OK",
    });
  };
  const onSubmit = (data) => {
    const uid = new Date().getTime().toString();
    let date = moment().tz("Asia/Singapore").format("LLLL");

    set(ref(db, "hotels/" + uid), {
      ...data,
      id: uid,
      check_in: dayjs(checkInvalue).format("ddd, MMM D, YYYY"),
      check_out: dayjs(checkOutvalue).format("ddd, MMM D, YYYY"),
      created_at: date,
    });

    Swal.fire({
      title: "Reservation successful",
      text: "Please expect an email from us.",
      icon: "success",
      confirmButtonText: "OK",
    });

    const autoMessageRegistered = `<div> <p>Good day!</p><p>
        Kindly check below details for hotel reservation of ${data.name} </p> 
        <table style="border:1px solid black;">
            <tr>
                <td style="border:1px solid black;"><strong>Id:</strong> </td>
                <td style="border:1px solid black;">${uid}</td>
            </tr>
            <tr>
                <td style="border:1px solid black;"><strong>Name:</strong> </td>
                <td style="border:1px solid black;">${data.name} </td>
            </tr>
            <tr>
                <td style="border:1px solid black;"><strong>Email:</strong> </td>
                <td style="border:1px solid black;">${data.email}</td>
            </tr>
            <tr>
                <td style="border:1px solid black;"><strong>Check-in:</strong> </td>
                <td style="border:1px solid black;">${dayjs(
                  checkInvalue,
                ).format("ddd, MMM D, YYYY")}</td>
            </tr>
            <tr>
                <td style="border:1px solid black;"><strong>Check-out:</strong> </td>
                <td style="border:1px solid black;">${dayjs(
                  checkOutvalue,
                ).format("ddd, MMM D, YYYY")}</td>
            </tr>
            <tr>
                <td style="border:1px solid black;"><strong>Flight Details:</strong> </td>
                <td style="border:1px solid black;">${data.flight_details}</td>
            </tr>
            <tr>
                <td style="border:1px solid black;"><strong>Hotel Name:</strong> </td>
                <td style="border:1px solid black;">${data.hotel_name}</td>
            </tr>
            <tr>
                <td style="border:1px solid black;"><strong>Room Type:</strong> </td>
                <td style="border:1px solid black;">${data.room_type}</td>
            </tr>    
            <tr>
                <td style="border:1px solid black;"><strong>Hotel Membership:</strong> </td>
                <td style="border:1px solid black;">${
                  data.hotel_membership
                }</td>
            </tr>    
            <tr>
                <td style="border:1px solid black;"><strong>Contact Number:</strong> </td>
                <td style="border:1px solid black;">${data.contact_number}</td>
            </tr>     
            <tr>
                <td style="border:1px solid black;"><strong>Airport Transfer:</strong> </td>
                <td style="border:1px solid black;">${
                  data.airport_transfer ? "yes" : "no"
                }</td>
            </tr>    
            <tr>
                <td style="border:1px solid black;"><strong>Request:</strong> </td>
                <td style="border:1px solid black;">${data.request}</td>
            </tr>                                      
        </table>
        <p>Thank you!</p> 
        <p>FIBS Admin</p></div>`;

    //    const newRegistered = {
    //      name: data.name,
    //      sendto: 'customerservice@fibsglobalconference.com',
    //     //  sendto: 'flytechph@gmail.com',
    //      subject: `Fibs Hotel Reservation - ${data.name}`,
    //      message: autoMessageRegistered
    //    };

    //    axios.post(`https://api.fibsglobalconference.com/v2`, null, {
    //      params: newRegistered
    //      })
    //    .then((response) => {
    //     //  console.log(response.data);
    //    })
    //    .catch((error) => {
    //      console.log("error",error);
    //    })

    reset();
  };

  return (
    <>
      <Navbar />
      <SubHeader
        title="HOTEL"
        image={require("assets/img/Macau-2026/hotel_banner.jpg")}
      />
      <div className="wrapper position-relative">
        <div className="main my-5">
          <section className="section gb nopadtop">
            <div className="container">
              <div className="boxed boxedp4">
                <div className="row">
                  <div className="col-md-12 section-title">
                    <h2 className="text-center font-weight-bold">HOTEL</h2>
                  </div>
                </div>

                <div className="col-md-12 mb-5">
                  <div className="bg-light my-3">
                    <section className="position-relative overflow-hidden pt-3 pt-md-5 pb-3">
                      <div className="container-fluid position-relative">
                        <div className="row align-items-sm-center align-items-md-start">
                          <div className="mx-3 mx-md-5 text-justify">
                            <p className="font-weight-bold mb-0">
                              Studio City Hotel, Macau
                            </p>
                            <p className="fs-5 w-lg-60 mb-0 mx-auto mt-2">
                              Conveniently located just a 10-minute drive from
                              Macau International Airport, Studio City Hotel
                              offers a comfortable and well-appointed stay for
                              business and leisure travellers alike. Guests can
                              enjoy complimentary Wi-Fi, modern in-room
                              amenities, and access to a relaxing sauna.
                            </p>
                            <p className="fs-5 w-lg-60 mb-0 mx-auto mt-2">
                              The hotel is home to the{" "}
                              <span className="font-weight-bold">
                                Golden Reel
                              </span>
                              , the world’s first and highest figure-8 Ferris
                              wheel, as well as the immersive{" "}
                              <span className="font-weight-bold">
                                Batman Dark Flight
                              </span>{" "}
                              simulation experience — signature attractions that
                              add a unique touch to your stay.
                            </p>
                            <p className="fs-5 w-lg-60 mb-0 mx-auto mt-2">
                              Studio City features a range of upscale
                              facilities, including a coffee lounge, a grand
                              ballroom, and 24-hour room service. Guests with
                              vehicles can take advantage of free private
                              on-site parking. For those looking to unwind, the{" "}
                              <span className="font-weight-bold">
                                Zensa Spa
                              </span>{" "}
                              and a spacious outdoor pool offer the perfect
                              retreat after a day of conference sessions or
                              meetings.
                            </p>
                          </div>

                          {/* <TableContainer
                            component={Paper}
                            className="mx-3 mx-md-5 mt-5 mt-md-3"
                          >
                            <Table sx={{ tableLayout: "fixed", width: "100%" }}>
                            
                              <colgroup>
                                <col style={{ width: "170px" }} />
                                {dates.map((_, index) => (
                                  <col key={index} style={{ width: "100px" }} />
                                ))}
                              </colgroup>

                              <TableHead>
                                <TableRow>
                                  <TableCell colSpan={dates.length + 1}>
                                    Celebrity King Room (42 sqm)
                                  </TableCell>
                                </TableRow>

                                <TableRow>
                                  <TableCell>Room Type</TableCell>
                                  {dates.map((date) => (
                                    <TableCell
                                      key={date}
                                      align="center"
                                      sx={{ border: "1px solid lightgray" }}
                                    >
                                      {date}
                                    </TableCell>
                                  ))}
                                </TableRow>
                              </TableHead>

                              <TableBody>
                                {roomData.map((room) => (
                                  <TableRow key={room.type}>
                                    <TableCell
                                      sx={{
                                        padding: "18px",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        display: "-webkit-box",
                                        WebkitLineClamp: 2,
                                        WebkitBoxOrient: "vertical",
                                        whiteSpace: "normal",
                                        wordBreak: "break-word",
                                        borderBottom: "none",
                                      }}
                                    >
                                      {room.type}
                                    </TableCell>

                                    {dates.map((date) => (
                                      <TableCell
                                        key={date}
                                        align="center"
                                        sx={{ border: "1px solid lightgray" }}
                                      >
                                        {room.prices[date]}
                                      </TableCell>
                                    ))}
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </TableContainer> 

                          <div className="mx-5 my-4">
                            <p>
                              <small>
                                Charges are subject to change without prior
                                notice
                              </small>
                            </p>
                            <p className="fs-5 w-lg-60">
                              <span className="font-weight-bold">Address:</span>{" "}
                              Estrada do Istmo, Macau
                            </p>
                          </div>
                          */}

                          <div className="container mt-5">
                            <div className="card shadow-sm border-0">
                              <div className="card-body p-4">
                                <h4 className="mb-3">
                                  <span className="text-highlight">
                                    Hotel Accommodation Update
                                  </span>
                                </h4>

                                <p>
                                  Please note that our preferential rate rooms
                                  at <strong>Studio City Hotel</strong> are
                                  <strong> now fully booked.</strong>
                                </p>

                                <p>
                                  For delegates who have not yet secured
                                  accommodation, <br /> we kindly recommend
                                  using external booking platforms to make your
                                  hotel arrangements directly.
                                </p>

                                <div className="table-responsive">
                                  <p className="text-start mb-3">
                                    <strong>
                                      Alternative nearby hotels include:
                                    </strong>
                                  </p>
                                  <table className="table table-bordered align-middle ">
                                    <thead className="">
                                      <tr>
                                        <th scope="col">
                                          <strong>Hotel</strong>
                                        </th>
                                        <th scope="col">
                                          <strong>Distance from Venue</strong>
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <td>
                                          <strong>W Macau – Studio City</strong>
                                        </td>
                                        <td className="text-muted">
                                          Adjacent to the venue
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <strong>The Londoner Macao</strong>
                                        </td>
                                        <td className="text-muted">
                                          Approx. 3 min walk
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <strong>The Parisian Macao</strong>
                                        </td>
                                        <td className="text-muted">
                                          Approx. 5–7 min walk
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>

                                <p className="mt-3">
                                  We encourage you to book early, as
                                  availability may be limited closer to the
                                  event dates.
                                </p>

                                <p className="mb-0">
                                  If you need any support, feel free to contact
                                  our team at{" "}
                                  <a href="mailto:customerservice@fibsglobalconference.com">
                                    customerservice@fibsglobalconference.com
                                  </a>
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>

                    {/* <section className="position-relative overflow-hidden pb-3">
                      <div className="container-fluid position-relative">
                        <div className="row align-items-sm-center align-items-md-start">
                          <div className="col-6 col-sm-3 mb-4 mb-sm-0">
                            <img
                              className="img-fluid rounded-4"
                              alt="..."
                              src={require("assets/img/Macau-2026/hotel/1.jpg")}
                            ></img>
                          </div>
                          <div className="col-6 col-sm-3 mb-4 mb-sm-0">
                            <img
                              src={require("assets/img/Macau-2026/hotel/3.jpg")}
                              className="img-fluid rounded-4 mb-3"
                              alt=""
                            />
                          </div>
                          <div className="col-sm-3 col-6">
                            <img
                              src={require("assets/img/Macau-2026/hotel/4.jpg")}
                              className="img-fluid rounded-4"
                              alt=""
                            />
                          </div>
                          <div className="col-sm-3 col-6">
                            <img
                              src={require("assets/img/Macau-2026/hotel/5.jpg")}
                              className="img-fluid rounded-4"
                              alt="Presidential Suite"
                            />
                          </div>
                        </div>
                      </div>
                    </section>

                    <div className="col-12 pb-5" id="pending" align="center">
                      <a
                        href="mailto:customerservice@fibsglobalconference.com?subject=FIBS Global Conference Hotel Booking | Studio City Hotel"
                        className="btn btn-danger"
                      >
                        Book Now{" "}
                      </a>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
        <PanelCountdown date="03/03/2026" />
        {/* <DarkFooter /> */}
      </div>
    </>
  );
}

export default Hotel;
